export const HIRING_AUTHORITY_STATUS_ID_MAP = Object.freeze({
  0: { id: 0, title: 'Inactive' },
  1: { id: 1, title: 'Active' },
  2: { id: 2, title: 'Deceased' },
  3: { id: 3, title: 'Retired ' }
});
